import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppThunk} from "../store";


export interface PersistedState {
    selectedCurrency: string;
}

const initialState: PersistedState = {
    selectedCurrency: "EUR",
};

const persistedSlice = createSlice({
    name: "persisted",
    initialState,
    reducers: {
        setSelectedCurrency(state: PersistedState, action: PayloadAction<string>): void {
            state.selectedCurrency = action.payload;
        },
    },
});

export const {setSelectedCurrency} = persistedSlice.actions;
export default persistedSlice

export const setSelectedCurrencyThunk =
    (currency: string): AppThunk =>
        async (dispatch): Promise<void> => {
            dispatch(setSelectedCurrency(currency));
        };
